var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMathWallet = function SvgMathWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "math-wallet_svg__a",
    width: 29,
    height: 29,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABmJLR0QA/wD/AP+gvaeTAAABKElEQVRIie2Pvy6DcRSGnw+xMDUdmYSkLHoLrDogUYuFy+AKpAb/YnYTGMxSkUjMDE1cAJVGoiqPwZE00aKNwfB7ki95z/e+5/fmQCKRSPSLWlT31XwHL68eqLN/XbrnBysdvHJ4u799b+CHshn1AqgCZWBSPVVH1FH1FJgI71K9UKd7O+lr6XJcsRnzmdpUx9Tx0CfhbUV2qe9L1UPgAZgCGuozsB2XLQILoXfCe4rsY+z2Xgq8Am9Zlt0CzfgaWZbdAy2gFbrx6Uf2LXZ/j1pS50Ln1Du1GPOGet6WPVfXQxcjm4t5Xi116hjq8O8qLgGoA0dALeYq8NKWPQauQ9ciW4/5psv73VEraqGLt6audvEKaqWnsrbl4W+8IXWwn91EIpH4X7wDfCzwwF2uPowAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#000",
      fillOpacity: 1
    },
    d: "M28 14c0 7.73-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0s14 6.27 14 14Zm0 0"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#math-wallet_svg__a"
  })));
};
export default SvgMathWallet;